import { render, staticRenderFns } from "./dui-expandable-option.vue?vue&type=template&id=be4b0c22&"
import script from "./dui-expandable-option.vue?vue&type=script&lang=js&"
export * from "./dui-expandable-option.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports